import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Restnutzungsdauer from "./pages/Restnutzungsdauer";
import Gutachten from "./pages/Gutachten";
import Investments from "./pages/Investments";
import Spezialgutachten from "./pages/Spezialgutachten";
import Kontakt from "./pages/Kontakt";
import Datenschutz from "./pages/Datenschutz";
import Impressum from "./pages/Impressum";
import UeberUns from "./pages/UeberUns";
import PreIpoPartner from "./pages/PreIpoPartner";
import FamilyOfficeAdvisory from "./pages/FamilyOfficeAdvisory";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/restnutzungsdauer" element={<Restnutzungsdauer />} />
          <Route path="/gutachten" element={<Gutachten />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/spezialgutachten" element={<Spezialgutachten />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/pre-ipo-partner" element={<PreIpoPartner />} />
          <Route path="/family-office-advisory" element={<FamilyOfficeAdvisory />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
